import { fetchPutResponse } from "./ApiUtilities";

export const fetchDocumentIds = async (
  isin,
  setDocumentIds,
  dateFilter,
  setInUseDocumentIds
) => {
  var requestBody = null;
  try {
    const category_theme = isin;
    const start_date = dateFilter.startDate || new Date().toISOString();
    const end_date = dateFilter.endDate || new Date().toISOString();
    const publication_timestamp = [start_date, end_date];

    requestBody = {
      category_theme,
      publication_timestamp,
    };
    const response = await fetchPutResponse(
      `document:filter?orderType=DESC&orderBy=publication_timestamp&offset=0&limit=100&getCount=false`,
      requestBody
    );
    const data = await response.json();
    const document_ids = data.results.records.map((x) => {
      return {
        doc_id: x.id,
        time_stamp: x.publication_timestamp,
        category_theme: x.category_theme,
        public_data_source_url: x.public_data_source_url,
      };
    });

    if (document_ids.length > 10) {
      let randomIndices = new Set();
      while (randomIndices.size < 10) {
        const randomIndex = Math.floor(Math.random() * document_ids.length);
        randomIndices.add(randomIndex);
      }
      const randomDocumentIds = Array.from(randomIndices).map(
        (index) => document_ids[index]
      );
      setInUseDocumentIds(randomDocumentIds);
    } else {
      setInUseDocumentIds(document_ids);
    }
    setDocumentIds(document_ids);
  } catch (error) {
    console.error("Error in fetching Document Ids:", error);
  } finally {
  }
};

export const askQuestion = async (
  setIsLoading,
  userInput,
  setUserInput,
  documentIdInput,
  inUseDocumentIds,
  setMessages,
  messages,
  setPageNumbers,
  getPageNumber
) => {
  if (!userInput.trim()) return;
  var document_ids = [];
  if (documentIdInput.trim()) {
    document_ids = [documentIdInput]; // Use the provided documentId
  } else {
    document_ids = inUseDocumentIds; // Fetch documentIds if not provided
  }
  setIsLoading(true);
  setUserInput("");
  const newMessage = { type: "question", text: userInput };
  setMessages([...messages, newMessage]);
  try {
    const document_id = documentIdInput
      ? [documentIdInput]
      : document_ids.map((x) => x.doc_id);
    const query = newMessage.text;
    const boolGetPageNumber = getPageNumber ? "true" : "false";
    const lastQuestionAndAnswer = messages
      .filter((message) => message.type === "question" || message.type === "answer")
      .slice(-4);

    let contextString = "";
    if (lastQuestionAndAnswer.length >2) {
      const lastQuestion = lastQuestionAndAnswer[0].type === "question" ? lastQuestionAndAnswer[0].text : lastQuestionAndAnswer[1].text;
      const lastAnswer = lastQuestionAndAnswer[1].type === "answer" ? lastQuestionAndAnswer[1].text : lastQuestionAndAnswer[0].text;
      const lastSourceUrl = lastQuestionAndAnswer[1].type === "answer" ? lastQuestionAndAnswer[1].source_url : lastQuestionAndAnswer[0].source_url;
      contextString = `question: ${lastQuestion} answer: ${lastAnswer}  source_url: ${lastSourceUrl}`;
    }
    const requestBody = {
      query: `${contextString}question: ${query}`,
      document_id,
    };
    if(document_id.length > 0) {
      const response = await fetchPutResponse(
        `conversation:query?page_numbers=${boolGetPageNumber}`,
        requestBody
      );
      const data = await response.json();
      if (!response.ok) {
        setTimeout(() => {
          setMessages((prev) => [...prev, { type: "answer", text: data.detail }]);
        }, 1000);
        setIsLoading(false);
        throw new Error(`Error: ${response.status}`);
      } else {
        setTimeout(() => {
          setMessages((prev) => [...prev, { type: "answer", text: data[0], source_url: data[1][0]["relevant_urls"] }]);
        }, 1000);
        setIsLoading(false);
        setUserInput("");
      }
      if (getPageNumber) {
        const pageNumbersArray = data[1][0]["page_numbers_used"];
        const seen = new Set();
        const uniquePageNumbers = pageNumbersArray.filter((item) => {
          return seen.has(item) ? false : seen.add(item);
        });
  
        setPageNumbers(uniquePageNumbers);
      }
    }
    else{
      setMessages((prev) => [...prev, { type: "answer", text: "No Context Available. Please modify filters and dates to continue."}]);
      setIsLoading(false);
    }
    
  } catch (error) {}
};

export const updateInUseDocumentId = (
  apiData,
  setInUseDocumentIds,
  chartData
) => {
  const selectedCompaniesList = chartData.map((x) => x.isin);
  const seriesData = apiData.filter((entry) => {
    return (
      selectedCompaniesList.length === 0 ||
      selectedCompaniesList.includes(entry.category_theme)
    );
  });

  if (apiData.length > 10) {
    let randomIndices = new Set();
    while (randomIndices.size < 10) {
      const randomIndex = Math.floor(Math.random() * apiData.length);
      randomIndices.add(randomIndex);
    }
    const randomDocumentIds = Array.from(randomIndices).map(
      (index) => apiData[index]
    );
    setInUseDocumentIds(randomDocumentIds);
  } else {
    setInUseDocumentIds(seriesData);
  }
};

export const fetchSingleDocumentId = async (
  setInUseDocumentIds,
  public_data_source_url
) => {
  var requestBody = null;
  try {
    requestBody = { public_data_source_url };
    const response = await fetchPutResponse(
      `/document:filter?orderType=DESC&orderBy=publication_timestamp&offset=0&limit=100000&getCount=false`,
      requestBody
    );

    const data = await response.json();
    const document_ids = data.results.records.map((x) => {
      return {
        doc_id: x.id,
        time_stamp: x.publication_timestamp,
        category_theme: x.category_theme,
      };
    });
    setInUseDocumentIds(document_ids);
  } catch (error) {
    console.error("Error in fetching Document Ids:", error);
  } finally {
  }
};
